import { render, staticRenderFns } from "./WechatBlank.vue?vue&type=template&id=19206578&scoped=true&"
import script from "./WechatBlank.vue?vue&type=script&lang=js&"
export * from "./WechatBlank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19206578",
  null
  
)

export default component.exports